import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 14rem 14rem;
  width: 100%;
  margin-bottom: 4rem;
  gap: 2rem;

  @media (max-width: 767px) {
    margin-bottom: 3rem;
  }
`

export const Button = styled.button`
  padding: 8px 30px;
  font-family: inherit;
  color: var(--color-blue-default);
  background-color: transparent;
  border: 1px solid var(--color-mystic);
  transition: var(--transition-control) ease;
  appearance: none;
  cursor: pointer;
`
